import React, { useEffect, useState, useMemo } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { AddConstructionOrderApi } from "./ConstructionOrderAction";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { getCategoryData } from "../../AddDetails/categories/Catagory.action";
import { getCustomerData } from "../../AddDetails/AddCustomer/Customer.action";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import moment from "moment";


const AddConstructionOrder = (props) => {
    const { t } = useTranslation();
    const [categories, setCategories] = useState([]);
    const [customerId, setCustomerId] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
    const [deliveryDate, setDeliveryDate] = useState(moment().format("YYYY-MM-DD"));
    const [sellingPrice, setSellingPrice] = useState(0);
    const [comment, setComment] = useState("");


    const saveConstructionOrder = () => {
        const payload = {
            date,
            deliveryDate,
            categories,
            sellingPrice,
            comment,
            customerDetails: {
                customerId: customerId,
                name: customerName,
            },
        };
        props.AddConstructionOrderApi(payload, showSuccessAlert, showErrorAlert);
        setCategories([])
        setCustomerId("")
        setCustomerName("")
        setSellingPrice(0)
    };


    const handleCategoryChange = (selected) => {
        const formatted = selected ? selected.map((item) => ({
            _id: item.value,
            name: item.label,
        })) : [];
        setCategories(formatted);
    };
    const categoryOptions = useMemo(() => {
        return props.categoryList?.data?.map((item) => ({
            value: item._id,
            label: item.name,
        })) || [];
    }, [props.categoryList]);
    const selectedOptions = useMemo(() => {
        return categoryOptions.filter((opt) => categories.some((c) => c._id === opt.value));
    }, [categories, categoryOptions]);


    const customerOptions = useMemo(() => {
        return props.customerDataList?.map((item) => ({
            value: item._id,
            label: item.name,
        })) || [];
    }, [props.customerDataList]);
    const handleCustomerChange = (selected) => {
        setCustomerId(selected.value);
        setCustomerName(selected.label);
    };
    const selectedCustomer = useMemo(() => {
        return customerOptions.find((opt) => opt.value === customerId) || null;
    }, [customerId, customerOptions]);


    useEffect(() => {
        props.setHeading("New Construction Order");
        props.getCategoryData();
        props.getCustomerData();
    }, []);


    if (props.isAddingConstructionOrder || props.isFetchingcategoryList || props.isFetchingCustomer) {
        return <GlobalSpinner />
    }

    return (
        <Container fluid>
            <Row>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>{t("Date")} *</b></Form.Label>
                        <Form.Control
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>{t("SelectCategories")} *</b></Form.Label>
                        <Select
                            placeholder="Select Categories"
                            options={categoryOptions}
                            isMulti
                            value={selectedOptions}
                            onChange={handleCategoryChange}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>{t("SelectCustomer")} *</b></Form.Label>
                        <Select
                            placeholder="Select Customer"
                            options={customerOptions}
                            value={selectedCustomer}
                            onChange={handleCustomerChange}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>{t("DeliveryDate")} *</b></Form.Label>
                        <Form.Control
                            type="date"
                            value={deliveryDate}
                            onChange={(e) => setDeliveryDate(e.target.value)}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>{t("SellingPrice")} *</b></Form.Label>
                        <Form.Control
                            placeholder="Selling Price"
                            type="number"
                            value={sellingPrice}
                            min={0}
                            onChange={(e) => setSellingPrice(e.target.value)}
                        />
                    </Form.Group>
                </Col>
                <Col></Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>{t("Comment")}</b></Form.Label>
                        <Form.Control
                            placeholder="Comment"
                            as="textarea"
                            rows={2}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                        />
                    </Form.Group>
                </Col>
            </Row>


            <div className="sendDiv">
                <Button
                    variant="contained"
                    endIcon={<SendIcon />}
                    size="large"
                    disabled={!date || !categories.length || !customerId || !deliveryDate || !sellingPrice}
                    onClick={saveConstructionOrder}
                >
                    SAVE
                </Button>
            </div>

        </Container>
    );
};

const mapDispatchToProps = (dispatch) => ({
    AddConstructionOrderApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddConstructionOrderApi(data, showSuccessAlert, showErrorAlert)),
    setHeading: (data) => dispatch(setHeading(data)),
    getCategoryData: () => dispatch(getCategoryData()),
    getCustomerData: () => dispatch(getCustomerData()),
});

const mapStateToProps = (state) => ({
    isAddingConstructionOrder: state.ConstructionOrderReducer.isAddingConstructionOrder,
    isFetchingcategoryList: state.CategoryReducer.isFetchingcategoryList,
    categoryList: state.CategoryReducer.categoryList,
    isFetchingCustomer: state.CustomerReducer.isFetchingCustomer,
    customerDataList: state.CustomerReducer.customerDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddConstructionOrder);